import type { EChartsOption } from 'echarts';
import { keepTwoOrLine } from '@/utils/utils';

interface DeviationTrendItem {
  time: string;
  rate: number;
}

/** 偏差率趋势图配置 */
export const getDeviationTrendChartOption = (data: DeviationTrendItem[], pointName?: string): EChartsOption => {
  return {
    backgroundColor: 'transparent',
    grid: {
      bottom: 10,
    },
    color: ['#FFCB47'],
    tooltip: {
      trigger: 'axis',
      formatter: (params: any) => {
        const paramsArr = Array.isArray(params) ? params : [params];
        const p = paramsArr[0];
        return `<div style="font-weight:bold;margin-bottom:8px;">${p.axisValue}</div><div>${
          p.marker
        }偏差率：${keepTwoOrLine(p.value)}%</div>`;
      },
    } as any,
    xAxis: {
      type: 'category',
      data: data.map(d => d.time),
      axisLabel: { formatter: (v: string) => v },
    },
    yAxis: {
      type: 'value',
      name: '%',
    },
    series: [
      {
        type: 'line',
        name: pointName || '偏差率',
        data: data.map(d => d.rate),
        smooth: true,
        symbol: 'circle',
        symbolSize: 4,
        lineStyle: { width: 2, color: '#FFCB47' },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(255,203,71,0.2)' },
              { offset: 1, color: 'rgba(255,203,71,0.05)' },
            ],
          },
        },
      },
    ],
  };
};

/** 长流水排名条形图配置 */
interface LongFlowRankingItem {
  name: string;
  usage: number;
  percent: number;
}

export const getLongFlowBarOption = (data: LongFlowRankingItem[]): EChartsOption => {
  const reversedData = [...data].reverse();

  return {
    backgroundColor: 'transparent',
    color: ['#4FC3F7'],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params: any) => {
        const paramsArr = Array.isArray(params) ? params : [params];
        const p = paramsArr[0];
        const item = data.find(d => d.name === p.name);
        return `<div>${p.marker}${p.name}</div><div>累计流量：${keepTwoOrLine(item?.usage)} m³</div>`;
      },
    } as any,
    xAxis: {
      type: 'value',
    },
    yAxis: {
      type: 'category',
      data: reversedData.map(r => r.name),
      axisLabel: {
        formatter: (v: string) => (v.length > 12 ? v.slice(0, 12) + '...' : v),
      },
    },
    series: [
      {
        type: 'bar',
        data: reversedData.map(r => r.usage),
        barMaxWidth: 30,
        itemStyle: {
          borderRadius: [0, 4, 4, 0],
          color: '#4FC3F7',
        },
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(255,255,255,0.05)',
          borderRadius: [0, 4, 4, 0],
        },
      },
    ],
  };
};
